// extracted by mini-css-extract-plugin
export default {"container":"Search_container__JDaLY","input":"Search_input__PXR0c","buttons":"Search_buttons__EYm8o"};